import type { EvidenceItem } from '../types';

interface EvidenceCardProps {
  evidence: EvidenceItem;
  index?: number;
}

function confidenceColor(c: number): string {
  if (c >= 0.8) return '#065f46';
  if (c >= 0.5) return '#92400e';
  return '#991b1b';
}

function confidenceBg(c: number): string {
  if (c >= 0.8) return '#d1fae5';
  if (c >= 0.5) return '#fef3c7';
  return '#fee2e2';
}

export function EvidenceCard({ evidence, index }: EvidenceCardProps) {
  const pct = Math.round(evidence.confidence * 100);

  return (
    <div
      style={{
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        padding: '12px 14px',
        backgroundColor: '#fafafa',
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
        {index !== undefined && (
          <span
            style={{
              fontSize: '11px',
              fontWeight: 700,
              color: '#9ca3af',
              minWidth: '20px',
            }}
          >
            #{index + 1}
          </span>
        )}
        <p style={{ margin: 0, fontSize: '13px', color: '#111827', flex: 1, lineHeight: 1.5 }}>
          {evidence.claim}
        </p>
        <span
          style={{
            fontSize: '11px',
            fontWeight: 700,
            padding: '2px 6px',
            borderRadius: '4px',
            backgroundColor: confidenceBg(evidence.confidence),
            color: confidenceColor(evidence.confidence),
            whiteSpace: 'nowrap',
          }}
        >
          {pct}% conf
        </span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <span style={{ fontSize: '12px', color: '#6b7280' }}>{evidence.source}</span>
        {evidence.sourceUrl && (
          <a
            href={evidence.sourceUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: '12px',
              color: '#2563eb',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '2px',
            }}
          >
            ↗ View Source
          </a>
        )}
        <span style={{ fontSize: '11px', color: '#9ca3af', marginLeft: 'auto' }}>
          {new Date(evidence.retrievedAt).toLocaleDateString()}
        </span>
      </div>
    </div>
  );
}
